import {Component, Host, h, Element, Prop, State, Event, EventEmitter} from '@stencil/core';
import {loadApi} from "../../utils/google-maps.service";

@Component({
  tag: 'bam-google-autocomplete',
  styleUrl: 'bam-google-autocomplete.scss',
  shadow: false
})
export class BamGoogleAutocomplete {
  @Element() el: HTMLElement
  @Prop() placeholder: string
  @Prop() dependsOn: string
  @Prop() country: string
  @State() disabled: boolean = true
  private countryCodes: string[]
  private dependsOnFormElement: HTMLFormElement
  private autocompleteInput: HTMLInputElement
  private autocomplete: google.maps.places.Autocomplete
  @Event() fillInAddressEvent: EventEmitter<{}>;  // eslint-disable-line @typescript-eslint/no-empty-object-type

  componentDidLoad() {
    loadApi.then(() => this.initAutoComplete())
    if (this.dependsOn) {
      this.dependsOnFormElement = document.querySelector(`#${this.dependsOn}`)
      if (this.dependsOnFormElement) {
        this.dependsOnFormElement.addEventListener('balChange', this.dependsOnChangedValue)
        if (this.dependsOnFormElement.value !== '') {
          this.disabled = false
        }
      } else {
        console.info('no depends on element found');
      }
    }

    this.countryCodes = this.country.split(',').map(c => c.trim())
    this.autocompleteInput = this.el.querySelector('#autocomplete').querySelector('[name="autocomplete"]')
  }

  initAutoComplete() {
    const valueInput = this.dependsOnFormElement?.value;
    this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput, {
      componentRestrictions: {country: valueInput !== '' ? [valueInput.substring(0, 2)] : this.countryCodes},
      types: ["geocode"],
    })
    this.autocomplete.addListener("place_changed", this.fillInAddress);
  }

  dependsOnChangedValue = (e: CustomEvent) => {
    this.disabled = e.detail === '' || e.detail === null;
    if (e.detail !== null) {
      if (e.detail.toLowerCase() === 'all') {
        this.autocomplete["componentRestrictions"].country = this.countryCodes
      } else {
        this.autocomplete["componentRestrictions"].country = [e.detail.substring(0, 2)]
      }
    }
  }

  fillInAddress = () => {
    const {formatted_address, geometry, name} = this.autocomplete.getPlace()

    if (name === '') {
      this.fillInAddressEvent.emit(
        {
          reset: true
        }
      );
    } else if (!geometry) {
      const request = {
        address: name
      }
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode(request, (data) => {
        if (data?.length) {
          this.fillInAddressEvent.emit(
            {
              reset: false,
              lat: data[0].geometry.location.lat(),
              lng: data[0].geometry.location.lng()
            }
          );
        }
      })
    } else {
      if (formatted_address !== undefined) {
        this.autocompleteInput.value = formatted_address
        this.fillInAddressEvent.emit(
          {
            reset: false,
            lat: geometry.location.lat(),
            lng: geometry.location.lng()
          }
        );
      } else {
        this.fillInAddressEvent.emit(
          {
            reset: true
          }
        );
      }
    }
  }

  render() {
    return (
      <Host>
        <bal-input
          id="autocomplete"
          name="autocomplete"
          type="search"
          autocomplete="off"
          placeholder={this.placeholder}
          disabled={this.disabled}
          data-tracking-label="Standort"
        >
        </bal-input>
      </Host>
    )
  }
}
